<template>
  <div class="table-tool-wrap">
    <div class="table-tool-box" :class="[showMoreBtn ? 'show-more-btn' : '']">
      <slot></slot>
      <div
        v-if="showMoreBtn"
        class="advanced-filter-icon"
        :class="[showMoreFilter ? 'active' : '']"
        @click.stop="showMoreFilter = !showMoreFilter"
      >
        <span class="open filter-icon">
          <svgIcon iconClass="filter" class="icon" />
        </span>
        <span class="close filter-icon">
          <svgIcon iconClass="close" class="icon" />
        </span>
      </div>
    </div>
    <!-- <transition
      enter-active-class="animated slideInDown"
      leave-active-class="animated slideOutUp"
    ></transition> -->
    <div
      class="advanced-filter-panel"
      :class="[showMoreFilter ? 'active' : '']"
    >
      <slot name="moreFilter"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props:{
    showMoreBtn: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      showMoreFilter: false,
    };
  },
  methods:{
    toggleFilter(flag){
      if(flag){
        this.showMoreFilter = flag
      }else{
        this.showMoreFilter = !this.showMoreFilter
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.table-tool-wrap {
  box-sizing: border-box;
  width: 100%;
  .table-tool-box {
    position: relative;
    margin-top: 0;
    height: 40px;
    padding: 0 0 15px 0;
    position: relative;
    &.show-more-btn{
      padding-right: 45px;
    }
    .advanced-filter-icon {
      position: absolute;
      top: 0;
      right: 0;
      width: 40px;
      height: 40px;
      background-color: #fff;
      align-items: center;
      transition: all 0.3s linear;
      overflow: hidden;
      cursor: pointer;
      & .filter-icon {
        display: block;
        width: 100%;
        height: 100%;
        font-size: 20px;
        color: #333;
        text-align: center;
        line-height: 40px;
        transition: transform 0.3s linear;
        overflow: hidden;
      }
      & .close {
        transform: translateY(0);
      }
      & .open {
        transform: translateY(0);
      }
      &:hover {
        transform: translateY(-1px);
        box-shadow: 2px 2px 10px 2px #ddd;
      }
      &:active {
        transform: scale(1.1);
      }
      &.active {
        background-color: #ffe21c;
        & .open {
          transform: translateY(-100%);
        }
        & .close {
          color: #fff;
          transform: translateY(-100%);
        }
      }
    }
    .tool-item {
      margin-bottom: 0;
    }
  }
  // 更多筛选
  .advanced-filter-panel {
    width: 100%;
    color: #333;
    height: 0;
    padding-top: 15px;
    transform: scaleY(0);
    transform-origin: right top;
    transition: all 0.5s cubic-bezier(0.09, 0.94, 0.75, 1.27);
    overflow: hidden;
    &.active {
      height: auto;
      transform: scaleY(1);
      transition: all 0.5s cubic-bezier(0.09, 0.94, 0.75, 1.27);
    }
    /deep/ {
      .filter-item {
        margin-bottom: 30px;
      }
    }
  }
}
</style>